import React, { useEffect, useCallback, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Events, handleAnalytics } from '@foxcorp/delta-web-analytics';
import { useDispatch, useSelector } from 'react-redux';
import useBreakpoint from 'hooks/useBreakpoint';
import { SITE_PLATFORM_MOBILE } from 'helpers/BreakpointHelper';
import { selectTab } from '../../BrowseActions';
import Tab from '../Tab';
import { isTabActive } from './FilterHelper';
import { isSearchResultsType, scrollTop } from '../FindProcessor';
import Styles from './Filter.module.scss';

const Filter = ({ isScrolled, tabs = [], searchValue, fetchingSearch, theme = {} }) => {
  const [dropdownOpenArr, setDropdownOpenArr] = useState([]);
  const dropdownOpen = useMemo(() => dropdownOpenArr.find(item => Boolean(item)), [
    dropdownOpenArr,
  ]);
  const dispatch = useDispatch();
  const { selectedTab } = useSelector(state => state.find);
  const { pathname: pathName = '' } = window.location;
  const breakpoint = useBreakpoint();

  const setDefaultDropdown = () => setDropdownOpenArr(new Array(tabs.length).fill(false));

  const onSelectTab = tabId => {
    handleAnalytics({
      event: Events.BUTTON_LINK_SELECTED,
      payload: {
        page_button_text: tabId,
        page_name: 'delta:web:find:landing',
        page_type: 'find:section-front',
      },
    });
    dispatch(selectTab(tabId));
    scrollTop();
  };

  const hideAndShowNavBar = useCallback(() => {
    const header = document.querySelector('header[data-test=header]');
    if (dropdownOpen) {
      header.style.top = '-100px';
    } else {
      header.style.top = '0';
    }
  }, [dropdownOpen]);

  useEffect(() => {
    const isMobile = breakpoint === SITE_PLATFORM_MOBILE;
    if (isMobile) hideAndShowNavBar();
  }, [dropdownOpen, breakpoint, hideAndShowNavBar]);

  useEffect(() => {
    if (tabs?.length) {
      setDefaultDropdown();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabs?.length]);

  return (
    <div
      className={classNames(
        Styles.filterContainer,
        theme.filterContainer,
        isScrolled && Styles.scrolled,
        searchValue && Styles.scrolled,
        dropdownOpen && Styles.open,
      )}
    >
      {tabs.map(({ headline = '', id = '', customViews = [] }, idx) => {
        const autoSelectTab = idx === 0;
        const newHeadline = headline;
        const isActive = () => isTabActive(pathName, newHeadline);

        const activeTab = searchValue ? id === selectedTab : isActive();

        return (
          <Tab
            autoSelectTab={autoSelectTab}
            activeTab={
              fetchingSearch && !isSearchResultsType(id)
                ? isTabActive(pathName, newHeadline)
                : activeTab
            }
            key={newHeadline}
            onClickTab={() => onSelectTab(id)}
            title={newHeadline}
          />
        );
      })}
    </div>
  );
};

Filter.propTypes = {
  fetchingSearch: PropTypes.bool,
  isScrolled: PropTypes.bool,
  searchValue: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({})),
  theme: PropTypes.shape({}),
};

export default Filter;
